import { resources } from "@constants/hardcoded-strings";
import { QueryParameter } from "@idw-types/common";
import { WorkflowReportSearchResultsTypes } from "@idw-types/state/workflow-report-state";
import {
    setPartialWorkflowReportSearchResultsLoading,
    setWorkflowReportSearchResultsPassRateAndOverTime
} from "@redux/actions/workflow-report-actions";
import { getWorkflowReportPassRatesRequest } from "@requests/reports/get-workflow-report-pass-rates";
import { getWorkflowReportPassRatesOverTimeRequest } from "@requests/reports/get-workflow-report-pass-rates-over-time";
import { handleResponse } from "@utils/promise-util";
import { Dispatch } from "redux";

export const getWorkflowReportSearchResultsPassRateAndOverTimeReduxRequest = (dispatch: Dispatch) => async (
    queryParameters: Array<QueryParameter> 
) => {
    dispatch(setPartialWorkflowReportSearchResultsLoading(true, WorkflowReportSearchResultsTypes.passRatesAndPassRateOverTime));

    const [
        passRatesResponse,
        passRatesOverTimeResponse
    ] = await Promise.allSettled([
        getWorkflowReportPassRatesRequest(queryParameters),
        getWorkflowReportPassRatesOverTimeRequest(queryParameters)
    ]);

    const passRatesData = handleResponse(
        dispatch,
        passRatesResponse,
        resources.requests.getWorkflowReportPassRates.error.title,
        resources.requests.getWorkflowReportPassRates.error.message,
    );

    const passRatesOverTimeData = handleResponse(
        dispatch,
        passRatesOverTimeResponse,
        resources.requests.getWorkflowReportPassRatesOverTime.error.title,
        resources.requests.getWorkflowReportPassRatesOverTime.error.message,
    );

    dispatch(setWorkflowReportSearchResultsPassRateAndOverTime(passRatesData, passRatesOverTimeData));

};